// extracted by mini-css-extract-plugin
export default {"frameGradient":"BottomBar_frameGradient__1Q7kt","Allblack":"BottomBar_Allblack__mSJhp"};